import { render, staticRenderFns } from "./DeleteAllTranslationsModal.vue?vue&type=template&id=555ae74c&scoped=true&"
import script from "./DeleteAllTranslationsModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteAllTranslationsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ae74c",
  null
  
)

export default component.exports